import { render, staticRenderFns } from "./AddProfilesMailCallback.vue?vue&type=template&id=5f1b7b02&scoped=true&"
import script from "./AddProfilesMailCallback.vue?vue&type=script&lang=ts&"
export * from "./AddProfilesMailCallback.vue?vue&type=script&lang=ts&"
import style0 from "./AddProfilesMailCallback.vue?vue&type=style&index=0&id=5f1b7b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b7b02",
  null
  
)

export default component.exports